/* import __COLOCATED_TEMPLATE__ from './copy-button.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
// eslint-disable-next-line ember/no-classic-components
import Component from '@glimmer/component';
import { guidFor } from '@ember/object/internals';
import { arg, forbidExtraArgs } from 'ember-arg-types';
import { string, oneOf, boolean, oneOfType, func, element } from 'prop-types';
let CopyButtonComponent = (_dec = arg(oneOfType([string, func])), _dec2 = arg(oneOfType([string, func])), _dec3 = arg(oneOf(['copy', 'cut'])), _dec4 = arg(boolean), _dec5 = arg(oneOfType([string, element])), _dec6 = arg(string), _dec7 = arg(boolean), _dec8 = arg(boolean), forbidExtraArgs(_class = (_class2 = class CopyButtonComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "guid", guidFor(this));
    _initializerDefineProperty(this, "text", _descriptor, this);
    _initializerDefineProperty(this, "target", _descriptor2, this);
    _initializerDefineProperty(this, "action", _descriptor3, this);
    _initializerDefineProperty(this, "delegateClickEvent", _descriptor4, this);
    _initializerDefineProperty(this, "container", _descriptor5, this);
    _initializerDefineProperty(this, "buttonType", _descriptor6, this);
    _initializerDefineProperty(this, "onError", _descriptor7, this);
    _initializerDefineProperty(this, "onSuccess", _descriptor8, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "text", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "action", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "delegateClickEvent", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "container", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "buttonType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'button';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "onError", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "onSuccess", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { CopyButtonComponent as default };